import React from 'react'
import { connect } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import DNS from '../../containers/Service/DNS'
import { checkPermission } from '../../utils/Auth/AuthService'
import { IUserState } from '../../store/user/types'

type TProps = {
    user: Pick<IUserState, 'permissions'>
}

export const ServiceDnsPanelBase: React.FC<TProps> = ({ user }) => {
    const canReadDns =
        checkPermission('dns.read', user.permissions) ||
        checkPermission('dns.write', user.permissions)

    if (!canReadDns) {
        return null
    }

    return (
        <Card className="service-detail-card shadow-sm border-0 mt-4">
            <CardBody>
                <div className="service-detail-card__title mb-3">
                    DNS Management
                </div>
                <DNS embedded />
            </CardBody>
        </Card>
    )
}

const mapStateToProps = ({ user }: { user: IUserState }) => ({
    user,
})

export default connect(mapStateToProps)(ServiceDnsPanelBase)
